import { useFormats } from "@portal/hooks/use-formats";
import { GrowDate } from "@sinecycle/growcomponents";

interface DateTextProps
  extends Omit<React.ComponentProps<typeof GrowDate>, "format"> {
  currentDate?: boolean;
}
function DateText(props: DateTextProps) {
  const { dateformat, currentDate } = useFormats();
  const value = props.currentDate ? currentDate : props.value;
  return <GrowDate {...props} value={value} format={dateformat} />;
}

export { DateText };
